import React from 'react';
import cn from 'classnames';
import StickyFooter from '@framework/ui/Organisms/StickyFooter';
import { footerCollection } from './footerCollection';
import { IFooter } from '@/finsight/domain/vo/IFooter';

import styles from './footer.module.scss';

interface IFooterProps {
  config?: IFooter,
}

const Footer = ({
  config = footerCollection,
}: IFooterProps) => {
  return (
    <StickyFooter
      contentClassName={ cn(styles.content, styles.contentWidth, styles.footerGroupDivider) }
      navigationClassName={ cn(styles.navigation, styles.contentWidth) }
      linksContainerClassName={ styles.linksContainer }
      logoClassName={ styles.logoPosition }
      config={ config }
    />
  );
};

export default Footer;
